<template>
  <div class="mc-report-view__table">
    <div class="row">
      <!-- Search -->
      <div class="col-md-12">
        <div class="mc-table-view">
          <div id="tickets-table_filter"
            class="dataTables_filter text-md-end float-end"
          >
            <label
              class="d-inline-flex align-items-center mc-table-view__search"
            >
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="ms-2"
                @input="searchData"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table
              :rows="3"
              :columns="fields.length"
              :table-props="{ bordered: false, striped: true }"
            >
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table
          class="datatables"
          :items="listData"
          :fields="fields"
          bordered
          responsive="lg"
          show-empty
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(vehicle)="data">
            {{
              data.item.reportDailyVehicle.vehicle
                ? data.item.reportDailyVehicle.vehicle.licensePlate
                : "-"
            }}
          </template>

          <template #cell(vehicleType)="data">
            {{
              data.item.reportDailyVehicle.vehicle
                ? data.item.reportDailyVehicle.vehicle.vehicleType
                  ? data.item.reportDailyVehicle.vehicle.vehicleType.manufacturer
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.reportDailyVehicle.vehicle
                ? data.item.reportDailyVehicle.vehicle.vehicleType
                  ? data.item.reportDailyVehicle.vehicle.vehicleType.model
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.reportDailyVehicle.vehicle
                ? data.item.reportDailyVehicle.vehicle.vehicleType
                  ? data.item.reportDailyVehicle.vehicle.vehicleType.type
                  : "-"
                : "-"
            }}
          </template>

          <template #cell(vehicleHub)="data">
            {{ data.item.vehicleHub }}
          </template>

          <template #cell(startTime)="data">
            {{
              data.item.reportDailyVehicle
                ? momentDateShortMonth(data.item.reportDailyVehicle.startTime)
                : "-"
            }}<br />
            <span class="text-muted">{{
              data.item.reportDailyVehicle
                ? momentTimeSeconds(data.item.reportDailyVehicle.startTime)
                : "-"
            }}</span>
          </template>

          <template #cell(stopTime)="data">
            {{
              data.item.reportDailyVehicle
                ? momentDateShortMonth(data.item.reportDailyVehicle.stopTime)
                : "-"
            }}<br />
            <span class="text-muted">{{
              data.item.reportDailyVehicle
                ? momentTimeSeconds(data.item.reportDailyVehicle.stopTime)
                : "-"
            }}</span>
          </template>

          <template #cell(startLocation)="data">
            {{ data.item.reportDailyVehicle.startAddress }}
          </template>

          <template #cell(endLocation)="data">
            {{ data.item.reportDailyVehicle.stopAddress }}
          </template>

          <template #cell(tripMileage)="data">
            {{ minimizeFloat(data.item.reportDailyVehicle.tripMileage) }}
          </template>

          <template #cell(totalTimeTrip)="data">
            {{ data.item.totalTimeTrip }}
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="fields.length > 0">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Menampilkan
            <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"
                @input="changePerPage">
            </b-form-select>
            entri.
            <p>
              Menampilkan
                <strong>{{ totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong> -
                <strong>{{ Math.min(totalRows, currentPage * perPage) }}</strong>
                dari
                <strong>{{ totalRows }}</strong>
            </p>
        </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage" @change="changePage">
              </b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_REPORT_DAILY_VEHICLE_MONITORING } from "@/services/api/report/report";
import moment from "moment";
import { Helper,debounce } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_EXCEL_REPORT_DAILY_VEHICLE_MONITORING } from "@/services/api/report/excel";
import { EXPORT_PDF_REPORT_DAILY_VEHICLE_MONITORING } from "@/services/api/report/pdf";

moment.locale("id");

export default {
  name: "DailyVehicleTable",
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      reportDailyVehicleMonitoring: {
        reportDailyVehicles: [],
      },
      fields: [],
      isLoading: false,
      fileName: "",
      openSection: false,
      periode: [],
      filtersField: [],
      filteredItems: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.reportDailyVehicleMonitoring.reportDailyVehicles.length;
    },
    listData() {
      return this.reportDailyVehicleMonitoring.reportDailyVehicles;
    },
  },
  mounted() {
    this.totalRows = this.reportDailyVehicleMonitoring.reportDailyVehicles.length;
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    changePerPage(perPage) {
      this.perPage = perPage
      this.currentPage = 1
      this.refreshData(this.periode, this.filtersField, this.driver, this.fields)
    },

    changePage(page) {
      this.currentPage = page
      this.refreshData(this.periode, this.filtersField, this.driver, this.fields)
    },

    searchData: debounce(function () {
      this.currentPage = 1
      this.refreshData(this.periode, this.filtersField, this.driver, this.fields)
    }, 500),

    refreshData(periode, filter, driver, fields) {
      this.reportDailyVehicleMonitoring.reportDailyVehicles = [];
      if (fields.length == 0) {
          this.reportDailyVehicleMonitoring.reportDailyVehicles = []
          return
      }
      this.isLoading = true;
      this.periode = periode;
      this.filtersField = filter;
      this.fields = fields;
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      var drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
        endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
        pagination:{
          page: this.currentPage,
          show: this.perPage,
        },
        ...filters,
        ...drivers,
        search:(this.filter !== null && this.filter !== undefined && this.filter.length > 0)?this.filter:''
      };

      var self = this;
      var getData = this.$apollo
        .query({
          query: GET_REPORT_DAILY_VEHICLE_MONITORING,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var data = res.data;
          self.totalRows = data.reportDailyVehicleMonitoring.reportDailyVehicles.pagination.total;
          if (data.reportDailyVehicleMonitoring.reportDailyVehicles.data.length === 0) {
            self.reportDailyVehicleMonitoring.reportDailyVehicles = [];
            self.isLoading = false;
            self.filteredItems = [];
            return [];
          }

          self.reportDailyVehicleMonitoring.reportDailyVehicles =
            data.reportDailyVehicleMonitoring.reportDailyVehicles.data;
          self.filteredItems = data.reportDailyVehicleMonitoring.reportDailyVehicles.data;

          self.isLoading = false;
        });

      return getData;
    },

    openTable(periode, filter, driver, fields) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData(periode, filter, driver, fields);
          this.openSection = false;
        }, 800);
      });
    },

    downloadToExcel(periode, filter, driver, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      var drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
        endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...drivers,
      };

      var downloadProgress = {
        name:
          "Pemantauan Harian Kendaraan " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "excel",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_DAILY_VEHICLE_MONITORING,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.excelDailyVehicleMonitoring.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },

    downloadToPdf(periode, filter, driver, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      var drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
        endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...drivers,
      };

      var downloadProgress = {
        name:
          "Pemantauan Harian Kendaraan " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_DAILY_VEHICLE_MONITORING,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.pdfDailyVehicleMonitoring.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },
  },
};
</script>
